import React from 'react';
import UserManagement from '../admin/UserManagement';

const CustomerPortal = () => (
    <UserManagement
        initialTab="CUSTOMER"
        hideTabs={true}
        pageTitle="Customer Portal"
        hideSecurity={true}
    />
);

export default CustomerPortal;
